import api from "../../../settings/api";
import { clearString } from "../../../utils/functions";
import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";

export interface Fetch {
    document: string;
    name?: string;
}

export interface CreateCustomerAction {
    type: string;
    payload: Fetch;
}

interface CreateCustomerResponse {
    data?: {
        nrc?: string;
    };
}

export default function* createCustomer({
    payload,
}: CreateCustomerAction): Generator<ReturnType<typeof call>, string, AxiosResponse<CreateCustomerResponse>> {
    try {
        const data = {
            document: clearString(payload.document.toLocaleUpperCase()),
            personType: 1,
            name: payload.name,
        };
        const response = yield call(api.post, `/v1/customers`, data);

        return response?.data?.data?.nrc ?? "";

    } catch (error) {
        return "";
    }
}